module.exports = __webpack_public_path__ + "static/img/thumb_30.94a3480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_30.png
// module id = UuQr
// module chunks = 0